import { defineMessages } from "react-intl";

const messages = defineMessages({
    loading: {
        id: "general.loading",
    },
    editScore: {
        id: "tasks.melodyTable.editScore",
    },
    stopEdit: {
        id: "tasks.stopEdit",
    },
    hideNotes: {
        id: "tasks.intervals.hideNotes",
    },
    createChordsScoreTooltip: {
        id: "score.chords3.saveTooltip",
    },
});

export default messages;
